// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__hvBp0","header":"style_header__1n6eI","tabs":"style_tabs__Us65i","tab":"style_tab__ChL-2"};